<template>
  <div class="left-box">
    <div class="head-bar">
      <a @click="homeClick"><img src="../assets/home-icon.png"/></a>
      <span @click="reloadClick" title="Refresh">{{que_name}}</span>
    </div>
    <div class="container clearfix">
      <div class="left-menu">
        <leftBar :menu-info="menuInfo" @event-menu-click="menuClick"></leftBar>
      </div>
      <div class="left-context">
        <quePage @event-que="updateQue" :is-show="pageInfo[0].isShow"></quePage>
        <topicPage @event-topic="updateTopic" :is-show="pageInfo[1].isShow"></topicPage>
        <recordPage @event-record="updateRecord" :is-show="pageInfo[2].isShow"></recordPage>
      </div>
    </div>
  </div>
</template>

<script>
import leftBar from "@/components/panel/leftBar";
import recordPage from "@/components/views/recordPage";
import topicPage from "@/components/views/topicPage";
import quePage from "@/components/views/quePage";


export default {
  name: "leftBox",
  data() {
    return {
      que_name:'题目名称',
      pageInfo:[
          {isShow: true},
          {isShow: false},
          {isShow: false}
      ],
      menuInfo:[
          {recordCount: undefined},
          {recordCount: 110},
          {recordCount: 90},
      ]
    }
  },
  methods:{
    reloadClick: function (){
      location.reload();
    },
    homeClick: function (){
      this.$router.push({
          name: "homeView"
      });
    },
    menuClick: function (index){
      for(let i = 0, len = this.pageInfo.length; i < len; i ++){
        this.pageInfo[i].isShow = false;
      }
      this.pageInfo[index].isShow = true;
    },
    updateQue: function (que_name){
      this.que_name = que_name;
    },
    updateTopic: function (recordCount){
      this.menuInfo[1].recordCount = recordCount;
    },
    updateRecord: function (recordCount){
      this.menuInfo[2].recordCount = recordCount;
    }
  },
  components: {
    leftBar,
    recordPage,
    topicPage,
    quePage
  }
}
</script>

<style scoped>
.left-box{
  position: relative;
  float: left;
  width: 35%;
  height: 90vh;
  border-right: 1px solid #eee;
  box-sizing: border-box;
  margin: 0px;
}
.head-bar{
  position: relative;
  background: #fff;
  border-bottom: 1px solid #eee;
  border-right: 1px solid #eee;
  height: 50px;
  line-height: 50px;
  padding-left:10px;
  white-space:nowrap;
  overflow: hidden;
  box-sizing: border-box;
  margin: 0px;
}
.head-bar img{
  width: 25px;
  height: 25px;
  cursor: pointer;
}
.head-bar span{
  color: #777;
  font-size: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-left: 20px;
  cursor: pointer;
}
.container{
  color: aliceblue;
  height: calc(100vh - 50px);
}
.left-menu{
  width: 50px;
  height: 100%;
  float: left;
  border-right: 1px solid #eee;
}
.left-context{
  margin-left: 50px;
  height: 100%;
  border-right: 1px solid #eee;
}
</style>
